import styled from 'styled-components'

export const tabTransformacaoApiStyle = {
  Container: styled.div`
    margin: 16px;
  `
}
